import { type FC } from "react";
import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useStorageBreakdownQuery } from "@/partner/entities/storage";
import { useIsBunnyProvider } from "@/partner/entities/platforms";

/**
 * Объём библиотеки Bunny узнать не удалось: нет аккаунтного ключа bunny.net
 * либо сбой core API. Цена хранения у Bunny считается только от объёма,
 * поэтому вся страница остаётся без размеров и без сумм, и об этом нужно
 * сказать прямо, а не показывать пустые ячейки и $0.00.
 *
 * Запрос тот же, что у StorageTotals (page 0, rowsPerPage 1) — Apollo
 * отдаёт его из кеша, лишнего обращения к бэкенду нет.
 */
export const StorageSizeUnavailableAlert: FC = () => {
  const { t } = useTranslation();
  const isBunny = useIsBunnyProvider();
  const { data } = useStorageBreakdownQuery({
    variables: { page: 0, rowsPerPage: 1 },
    fetchPolicy: "cache-and-network",
  });

  const totals = data?.storageBreakdown?.totals;
  if (!isBunny || !totals || totals.storageBytes != null) return null;

  return <Alert severity="warning">{t("storage.sizeUnavailableAlert")}</Alert>;
};
